import { endOfYear, startOfYear } from 'date-fns';
import { atom, useAtom, useAtomValue } from 'jotai';

const now = new Date();

const yearAtom = atom<number>(now.getFullYear());
export const useYear = () => useAtom(yearAtom);

const dateRangeAtom = atom<[Date, Date]>((get) => {
  const year = get(yearAtom);
  const d = new Date(year, 0, 1);
  return [startOfYear(d), endOfYear(d)];
});

export const useDateRange = () => useAtomValue(dateRangeAtom);

const resolutionAtom = atom<'month' | 'quarter'>('month');

export const useResolution = () => useAtom(resolutionAtom);
